import {
  getIncomeAndExpensesCardColumns,
  getGeneralExpensesCardColumns,
} from "./IncomeAndExpensesCard.config";

import IncomeAndExpensesCard from "./IncomeAndExpensesCard";

const IncomeAndExpensesCardContainer = ({
  totalApartments,
  totalParkings,
  incomeAndExpenses,
  generalExpenses,
}: any) => {
  const columnsIncomeAndExpenses = getIncomeAndExpensesCardColumns({
    totalApartments,
    totalParkings,
  });

  const columnsGeneralExpenses = getGeneralExpensesCardColumns();

  return (
    <IncomeAndExpensesCard
      incomeAndExpenses={incomeAndExpenses}
      columnsIncomeAndExpenses={columnsIncomeAndExpenses}
      generalExpenses={generalExpenses}
      columnsGeneralExpenses={columnsGeneralExpenses}
    />
  );
};

export default IncomeAndExpensesCardContainer;
